import { BoardScene } from "./BoardScene";
import { GameManager } from "./../../GameManager";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Utils";

export class PauseLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const tmpBackground = new Phaser.GameObjects.Graphics(this.scene);
        tmpBackground.fillStyle(0x000000, .001);
        tmpBackground.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(tmpBackground);

        const scaledItemsContainer = new Phaser.GameObjects.Container(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);
        scaledItemsContainer.scaleY = GameVars.scaleY;
        this.add(scaledItemsContainer);

        let bck = new Phaser.GameObjects.Image(this.scene, 0, 30, "texture_atlas_1", "layout_menu");
        scaledItemsContainer.add(bck);

        let title = new Phaser.GameObjects.Image(this.scene, -65, -250, "texture_atlas_1", "txt_menu");
        scaledItemsContainer.add(title);

        const closeButton = new Button(this.scene, 177, -225, "texture_atlas_1", "btn_x", "btn_x_hover");
        closeButton.onUp(this.onClickClose, this);
        scaledItemsContainer.add(closeButton);

        const resetButton = new Button(this.scene, -90, -60, "texture_atlas_1", "btn_reset", "btn_reset_hover");
        resetButton.onUp(this.onClickReset, this);
        scaledItemsContainer.add(resetButton);

        const resetText = new Phaser.GameObjects.Text(this.scene, -30, -60, "Reset", {fontFamily: "Arista", fontSize: "55px", color: "#09808D"});
        resetText.setOrigin(0, .5);
        scaledItemsContainer.add(resetText);

        const homeButton = new Button(this.scene, -90, 40, "texture_atlas_1", "btn_home", "btn_home_hover");
        homeButton.onUp(this.onClickHome, this);
        scaledItemsContainer.add(homeButton);

        const homeText = new Phaser.GameObjects.Text(this.scene, -30, 40, "Home", {fontFamily: "Arista", fontSize: "55px", color: "#09808D"});
        homeText.setOrigin(0, .5);
        scaledItemsContainer.add(homeText);

        const levelsButton = new Button(this.scene, -90, 140, "texture_atlas_1", "btn_lvls", "btn_lvls_hover");
        levelsButton.onUp(this.onClickLevels, this);
        scaledItemsContainer.add(levelsButton);

        const levelsText = new Phaser.GameObjects.Text(this.scene, -30, 140, "Levels", {fontFamily: "Arista", fontSize: "55px", color: "#09808D"});
        levelsText.setOrigin(0, .5);
        scaledItemsContainer.add(levelsText);

        const tutorialButton = new Button(this.scene, -90, 240, "texture_atlas_1", "btn_tuto", "btn_tuto_hover");
        tutorialButton.onUp(this.onClickTutorial, this);
        scaledItemsContainer.add(tutorialButton);

        const tutorialText = new Phaser.GameObjects.Text(this.scene, -30, 240, "Rules", {fontFamily: "Arista", fontSize: "55px", color: "#09808D"});
        tutorialText.setOrigin(0, .5);
        scaledItemsContainer.add(tutorialText);

        this.y = 1000;

        this.scene.tweens.add({
            targets: this,
            y: 0,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250
        });
    }

    private onClickLevels(): void {

        if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
            gdsdk.showAd();
            GameVars.typeAd = "DifficultyScene";
        } else {
            this.scene.cameras.main.fadeOut(300, 255, 255, 255);

            this.scene.cameras.main.once("camerafadeoutcomplete", function (): void {
                GameManager.enterDifficultySelectionScene();
            }, this); 
        } 
    }

    private onClickHome(): void {

        if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
            gdsdk.showAd();
            GameVars.typeAd = "SplashScene";
        } else {
            this.scene.cameras.main.fadeOut(300, 255, 255, 255);

            this.scene.cameras.main.once("camerafadeoutcomplete", function (): void {
                GameManager.enterSplashScene();
            }, this); 
        }
    }

    private onClickReset(): void {

        if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
            gdsdk.showAd();
            GameVars.typeAd = "BoardScene";
            GameVars.levelAd = GameVars.currentLevel;
        } else {
            this.scene.cameras.main.fadeOut(300, 255, 255, 255);

            this.scene.cameras.main.once("camerafadeoutcomplete", function (): void {
                GameManager.enterBoardScene();
            }, this); 
        }
    }

    private onClickTutorial(): void {

        BoardScene.currentInstance.hidePauseLayer();
        BoardScene.currentInstance.showRulesLayer();

        this.destroy();
    }

    private onClickClose(): void {

        GameVars.paused = false;

        this.scene.tweens.add({
            targets: this,
            y: 1000,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250,
            onComplete(): void {
                this.destroy();
            }, 
            onCompleteScope: this
        });

        BoardScene.currentInstance.hidePauseLayer();
    }
}
